module.exports = __webpack_public_path__ + "static/2017-PBM-fa75ed800ee52f5ab5c1fe8272557e4b.pdf";